import { getUIBlockerStyle } from './blocker';

export const getAudienceWizardStyle = (_, { palette = {} }) => ({
  ...getUIBlockerStyle({ palette }),

  wizardContainer: {},
});
